<div class="container">
    <div class="row">
        <div class="col-24">
            <h1 class="medium">Thank You!</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-16">            
            <h1 class="medium">Online Enrollment Confirmation # {{confirmationNumber}}</h1>
        </div>
    </div>
    <br />
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <p class="qtip-note bottom-20">(<strong>Note to Agent: </strong> Agent Provides Confirmation Number generated from the system.)</p><br />
                <p class="blue-text bottom-20">I would like to offer you a confirmation number {{confirmationNumber}}. This number will be used to confirm your enrollment.</p><br />
                <p class="blue-text bottom-20">Thank you for calling and have a great day! Goodbye!</p> <br />
                <p>Anthem Insurance Companies, Inc., Blue Cross and Blue Shield of Massachusetts, Inc., Blue Cross & Blue Shield of Rhode Island, and Blue Cross and Blue Shield of Vermont are the legal entities which have contracted as a joint enterprise with the Centers for Medicare & Medicaid Services (CMS) and are the risk-bearing entities for Blue MedicareRx (PDP) plans. The joint enterprise is a Medicare-approved Part D Sponsor. Enrollment in Blue MedicareRx (PDP) depends on contract renewal.</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24" >
            <a class="link-button link print" routerLink="/enrollment/print" target="_blank" >Print a hard copy of the enrollment</a>
                <!--<button class="button primary" (click)="printHardCopy()">Print a hard copy of the enrollment Form >></button>-->
        </div>
    </div>
    <div class="row" >
        <div class="col-24">
            <a class="link-button link pdf" (click)="SavePdf()">Save PDF of Completed Enrollment Data</a>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary bottom" (click)="enrollNew()">Enroll Another client</button>
        </div>
    </div>
   
</div>







